import * as React from 'react';
import { ReactElement } from 'react';
import { twMerge } from 'tailwind-merge';
import { FIELD } from '../__partials/field-classes';
import FormItem from '../__partials/form-item';
import HelpText from '../__partials/help-text';
import Label from '../__partials/label';
import useFieldId from '../__partials/use-field-id';

type IProps = {
  label?: string;
  status?: 'default' | 'error' | 'success';
  statusText?: string;
  helpText?: any;
  isDisabled?: boolean;
  isRequired?: boolean;
  className?: string;
} & React.InputHTMLAttributes<HTMLInputElement>;

const INPUT = twMerge(FIELD, 'min-h-11 py-0');

const Input = ({
  label,
  status = 'default',
  statusText,
  helpText,
  isDisabled,
  isRequired,
  className,
  id,
  name,
  ...props
}: IProps): ReactElement => {
  const inputId = useFieldId(id, name);

  return (
    <FormItem status={status} isDisabled={isDisabled}>
      {label && <Label label={label} statusText={statusText} id={inputId} />}
      <div className="flex [&>input]:flex-1">
        <input
          {...props}
          id={inputId}
          name={name}
          className={twMerge(INPUT, className)}
          disabled={isDisabled}
          required={isRequired}
        />
      </div>
      {helpText && <HelpText text={helpText} status={status} />}
    </FormItem>
  );
};

export default Input;
